export default "__VITE_ASSET__Dr0uXZ1K__"